// extracted by mini-css-extract-plugin
module.exports = {"iconPadding":"upgrade-button_iconPadding_3G-"};